import { gql, useQuery } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

const SCAN_PREFILL_FOR_CATEGORY = gql`
  query ScanPrefillForCategory($category: String!, $token: String) {
    scanPrefillForCategory(category: $category, token: $token)
  }
`;

export interface ScanPrefillForCategoryData {
  scanPrefillForCategory: string[];
}

export interface ScanPrefillForCategoryVariables {
  category: string;
  token?: string | null;
}

/**
 * Returns the list of service names detected by the website scan for a given
 * snippet category. Drives the "we detected these services" banner shown
 * above the service-selection question.
 */
export function useScanPrefillForCategoryQuery(category: string | null | undefined) {
  const { token, waitingForShareToken } = useShareTokenJwt();
  return useQuery<ScanPrefillForCategoryData, ScanPrefillForCategoryVariables>(SCAN_PREFILL_FOR_CATEGORY, {
    variables: { category: category ?? '', token },
    skip: !category || waitingForShareToken,
    fetchPolicy: 'cache-and-network',
  });
}
